const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

/**
 * Focuses the first focusable descendant element within a container.
 * @param container - The HTML element container to search within
 * @returns true if a focusable element was found and focused, false otherwise
 */
export const focusFirstDescendant = container => {
  const focusable = container.querySelector(FOCUSABLE_SELECTOR);
  if (focusable) {
    focusable.focus();
    return true;
  }
  return false;
};
//# sourceMappingURL=focus-first-element.js.map